export const ProductMappingFields = {
  code: { type: 'string', required: true },
  name: { type: 'string' },
  price: { type: 'number' },
  status: { type: 'string', validValues: ['Active', 'In Active', 'Draft'] },
  fullDescription: { type: 'string' },
  summary: { type: 'string' },
  forSale: { type: 'boolean' },
  coverImage: { type: 'string' },
  tags: { type: 'array' },
  remarks: { type: 'string' },
  quantity: { type: 'number', fieldName: 'inventory.quantityOnHand' },
}
